import { VesselRs6ModelBase } from './vessel-rs6-model';
import { Rs6UpdateInfo, Rs6Service } from '../services/rs6-service';
import { getLatestWeekDate } from '../utils/helpers';

export class VesselRs6ModelImpl extends VesselRs6ModelBase {
    public get latestUpdateDate() {
        return this._latestUpdateDate;
    }
    
    constructor() {
        super();
        this.getLatestUpdateDate().then(date => this._latestUpdateDate = date);
        setInterval(this._updateLatestUpdateDate, 60*60*1000); // update every hour
    }

    async getUpdateInfo(): Promise<Map<string, Rs6UpdateInfo>> {
        const updateInfo = await Rs6Service.getUpdateInfo();
        return updateInfo;
    }

    async getLatestUpdateDate() : Promise<string> {
        if( (<any>window)["appenv"].isLocal) {
            return ''
         }
        const updates = await this.getUpdateInfo();
        const values = Array.from(updates.values());
        const result = getLatestWeekDate(values.filter(u => u.licensed && u.week !== null).map(u => u.week!));
        
        if (result) {
            return result;
        }

        return "";
    }

    private _latestUpdateDate: string | null = null;

    private async _updateLatestUpdateDate() {
        const date = await this.getLatestUpdateDate();
        this._latestUpdateDate = date;
    }
}
